import React, { FC, useState } from 'react';
import styles from './New.module.scss';
import { PassInput } from 'components/shared/Input';
import { validatePassword } from 'sdk/utils/validation';
import { StringConstant } from 'utils/Constants';
import Button from 'components/shared/Button';
import supabase from 'sdk/api';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as IconInfo } from 'images/info.svg';
import { ReactComponent as IconInfo2 } from 'images/info2.svg';
import { ReactComponent as Success } from 'images/new-icons/Exactly.svg';

type Props = {
  password: string;
  setPassword: (password: string) => void;
  phone: string;
  email: string;
  name: string;
};

const Password: FC<Props> = ({ password, setPassword, phone, email, name }) => {
  const navigate = useNavigate();
  const [password2, setPassword2] = useState('');
  const [isPassVisible, setIsPassVisisble] = useState(false);
  const [passError, setPassError] = useState(false);
  const [passError2, setPassError2] = useState(false);
  const [error, setError] = useState('');
  const isPassValid = validatePassword(password) && password === password2;
  const [success, setSuccess] = useState(false);
  const [notSuccess, setNotSuccess] = useState(false);
const [first_name, last_name] = name.split(" ");

  const handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setPassword((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const handlePassword2Change = (e: React.FormEvent<HTMLInputElement>) => {
    setPassword2((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const handleSignUp = async () => {
    const { data: newUser, error: newUserError } = await supabase.auth.signUp({
      email,
      password,
    });

    if (newUserError) {
      return;
    }

    // Merging existing user profile with new auth user
    const { data: existingUser} = await supabase
      .from('user_profiles')
      .select('*')
      .eq('phone', phone)
      .maybeSingle();

    if (existingUser) {
      const { error: updateUserProfileError } = await supabase
        .from('user_profiles')  
        .update({
          id: newUser.user?.id,
          email,
          first_name,
          last_name,
          username: name
        })
        .eq('phone', phone);
    } else {
      const { error: newUserProfileError } = await supabase
        .from('user_profiles')
        .insert({
          id: newUser.user?.id,
          email,
          first_name,
          last_name,
          username: name,
          phone,
      });

          if (newUserProfileError) {
      setNotSuccess(true);
      return;
    }
    }



    setSuccess(true);
  };

  return (
    <div className={styles.email}>
      <div className={styles.step_header}>Step 3: Create Password</div>
      <div className={styles.password}>
        <PassInput
          className={styles.margin20}
          value={password}
          onChange={handlePasswordChange}
          isVisible={isPassVisible}
          switchVisibility={() => setIsPassVisisble(!isPassVisible)}
          error={passError}
          onBlur={() => setPassError(!isPassValid)}
          placeholder="New Password"
          wide
          white
        />

        <PassInput
          className={styles.margin20}
          value={password2}
          onChange={handlePassword2Change}
          isVisible={isPassVisible}
          switchVisibility={() => setIsPassVisisble(!isPassVisible)}
          error={passError}
          errorMessage={
            password === password2
              ? StringConstant.NEW_PASSWORD_ERROR
              : StringConstant.NEW_PASSWORD_MISMATCH
          }
          onBlur={() => setPassError(!isPassValid)}
          placeholder="Repeat Password"
          wide
          white
        />
      </div>
      {error && <div className={styles.error}>{error}</div>}
      <div className={styles.password_info}>
        <IconInfo />
        Password must be at least <span>8 characters long</span>
      </div>
      <Button wide darkGreen onClick={handleSignUp} disabled={!isPassValid}>
        Next
      </Button>

      {success && (
        <div className={styles.success} onClick={() => (window.location.href = '/profile/edit')}>
          <div className={styles.success__inner}>
            <Success />
            <div>Success</div>
            <div>You have successfully 
            created your account</div>
          </div>
        </div>
      )}
      {notSuccess && (
        <div className={styles.success} onClick={() => setNotSuccess(false)}>
          <div className={styles.success__inner}>
            <IconInfo2 />
            <div>Error</div>
            <div>Something went wrong, please try again later.</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Password;
